import { CABINS } from "app/constants";

/**
 * Get the language of the user based on the setting of his browser.
 * @returns {string} fr, en ... or undefined
 */
export function getUserLocale() {
	let language;
	// disable in node environment
	if (typeof self === "object") {
		language = navigator.languages
			? navigator.languages[0]
			: navigator.language || navigator.userLanguage;
	}
	return language ? language.substring(0, 2) : undefined;
}

export const getCabinLabelMessageId = cabinCode => {
	let cabinLabel = cabinCode;

	if (cabinCode === CABINS.FIRST) {
		cabinLabel = "quotation.flights.first.label";
	} else if (cabinCode === CABINS.ECONOMY) {
		cabinLabel = "quotation.flights.economy.label";
	} else if (cabinCode === CABINS.BUSINESS) {
		cabinLabel = "quotation.flights.business.label";
	} else if (cabinCode === CABINS.PREMIUM) {
		cabinLabel = "quotation.flights.premium.label";
	}

	return cabinLabel;
};
